import { mapGetters } from 'vuex'
import { omiseApi } from '@/api/omise.js'

export default {
  data() {
    return {
      hasCartarray: false,
      userId: null,
      sessionToken: null,
      pollingInterval: null,
      omisePaymentMethods: [],
      omisePublicKey: null
    }
  },
  created() {
    this.hasCartarray = localStorage.getItem('cartarray') !== null
  },
  computed: {
    ...mapGetters({
      currentLang: 'currentLang',
      pageProfile: 'getPageProfile',
      getSalePage: 'getSalePage'
    }),
    pageId() {
      return this.$route.query.pageid
        ? this.$route.query.pageid
        : this.$route.params.id
        ? this.$route.params.id
        : undefined
    },
    shopUrl() {
      let url
      if (
        this.hasCartarray &&
        ((this.getSalePage && this.getSalePage.is_active) || !this.userId)
      ) {
        url = '/salepage/' + this.pageId
      } else {
        url = '/ecommerce/' + this.pageId
        if (this.userId && this.userId != null && this.userId != '') {
          url += '?userid=' + this.userId
          if (
            this.sessionToken &&
            this.sessionToken != null &&
            this.sessionToken != ''
          ) {
            url += '&sessiontoken=' + this.sessionToken
          }
        }
      }
      return url
    },
    shopLink() {
      return `${window.location.origin}${this.shopUrl}`
    },
    isOmiseEnabled() {
      return (
        this.pageProfile.features.split(',').includes('omise') &&
        this.omisePublicKey
      )
    }
  },
  mounted() {
    if (this.$route.query.userid) {
      this.userId = this.$route.query.userid
    }
    if (this.$route.query.sessiontoken) {
      this.sessionToken = this.$route.query.sessiontoken
    }
    this.handleFetchOmiseConfig()
  },
  beforeDestroy() {
    this.stopPolling()
    this.$swal.close()
  },
  methods: {
    callbackUrl({ orderId }) {
      return `/order/detail?lang=${this.currentLang}&page_id=${
        this.pageId
      }&order_id=${orderId}&redirect_url=${encodeURIComponent(this.shopLink)}`
    },
    redirectUrl({ orderId }) {
      return `${window.location.origin}${this.callbackUrl({ orderId })}`
    },
    async handleFetchOmiseConfig() {
      try {
        const isOmiseEnabled = this.pageProfile.features
          .split(',')
          .includes('omise')
        if (!isOmiseEnabled) return
        const response = await omiseApi.getOmiseConfig({
          page_id: this.pageId,
          page_token: this.pageProfile.page_token
        })
        const {
          status,
          data: {
            config: { omise_public_key = '', omise_payment_methods = [] }
          }
        } = response
        if (status === 200) {
          window.OmiseCard.configure({
            publicKey: omise_public_key,
            locale: this.currentLang
          })
          this.omisePublicKey = omise_public_key
          this.omisePaymentMethods = omise_payment_methods
        }
      } catch (error) {
        this.$swal({
          title: 'เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง',
          type: 'error',
          confirmButtonText: this.$t('Confirm')
        })
      }
    },
    handlePayWithOmise({ pageId, orderId, amount }) {
      window.OmiseCard.open({
        amount: Number(amount) * 100,
        currency: 'THB',
        frameLabel: this.pageProfile.pagename
          ? this.pageProfile.pagename
          : 'Merchant name',
        submitLabel: this.$t('Payment'),
        image: this.pageProfile.pagelogo
          ? this.pageProfile.pagelogo
          : 'https://cdn.omise.co/assets/dashboard/images/omise-logo.png',

        otherPaymentMethods: this.omisePaymentMethods,
        onCreateTokenSuccess: async (nonce) => {
          const payload = {
            page_id: pageId ? pageId : this.pageProfile.pageid,
            order_id: orderId,
            token: nonce,
            currency: 'thb',
            return_uri: this.redirectUrl({ orderId })
          }
          const response = await omiseApi.postOmiseCreateCharge({
            data: payload,
            page_token: this.pageProfile.page_token
          })
          const {
            status,
            data: {
              data: { authorize_uri, source }
            }
          } = response
          if (status === 200) {
            if (
              source &&
              source.scannable_code &&
              source.scannable_code.image &&
              source.scannable_code.image.download_uri
            ) {
              this.handlePayPromptpay({
                amount,
                orderId,
                download_uri: source.scannable_code.image.download_uri
              })
              return
            }
            if (authorize_uri) {
              window.location.href = authorize_uri
              return
            }
          }
        },
        onFormClosed: () => {
          this.$router.push({ path: this.shopUrl })
        }
      })
    },
    handlePayPromptpay({ amount, orderId, download_uri }) {
      this.$swal({
        title: this.$t('Please scan the QR code for payment'),
        text: `${this.$t('Payment Amount')} ฿ ${Number(amount).toLocaleString(
          'th-TH',
          {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }
        )}`,
        imageUrl: download_uri,
        imageWidth: 250,
        imageAlt: 'PromptPay QR Code',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showCloseButton: false,
        showConfirmButton: false
      })
      this.startPolling({ orderId })
    },
    startPolling({ orderId }) {
      this.stopPolling()

      this.pollingInterval = setInterval(async () => {
        try {
          const response = await omiseApi.getOmisePaymentStatus({
            page_id: this.pageId,
            page_token: this.pageProfile.page_token,
            order_id: orderId
          })
          const {
            status,
            data: {
              data: { omise_status }
            }
          } = response
          if (status === 200) {
            if (omise_status !== 'pending') {
              this.$router.push({ path: this.callbackUrl({ orderId }) })
            }
          }
        } catch (error) {
          this.$swal({
            title: 'เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง',
            type: 'error',
            confirmButtonText: this.$t('Confirm')
          })
        }
      }, 2500)
    },
    stopPolling() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval)
        this.pollingInterval = null
      }
    }
  }
}
